import { FunctionComponent } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { StageType } from '@/model';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { StageSummaryItem } from '../../utils/buildStagesSummary';

type ReviewStagesChipsProps = {
  stages: StageSummaryItem[];
};

const CHIP_STYLE: Record<StageType, { bg: string; color: string; icon: string }> = {
  [StageType.LEAGUE]: { bg: 'green.50', color: 'green.700', icon: 'list' },
  [StageType.GROUP]: { bg: 'purple.50', color: 'brand.700', icon: 'grid' },
  [StageType.KNOCKOUT]: { bg: 'orange.50', color: 'orange.700', icon: 'git-merge' },
};

const PREFIX = 'pages.application_season.components.season_step3';

export const ReviewStagesChips: FunctionComponent<ReviewStagesChipsProps> = ({
  stages,
}) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderColor="gray.200" borderRadius="md" p={4}>
      <Text
        fontSize="12px"
        fontWeight="semibold"
        color="gray.500"
        letterSpacing="wide"
        mb={3}
      >
        {t(`${PREFIX}.stages_box_title`)}
      </Text>
      <Flex wrap="wrap" gap={2}>
        {stages.map((stage, index) => {
          const style = CHIP_STYLE[stage.type];
          return (
            <Flex
              key={`${stage.label}-${index}`}
              align="center"
              gap={1.5}
              bg={style.bg}
              color={style.color}
              borderRadius="full"
              px={3}
              py={1}
            >
              <ChakraFeatherIcon name={style.icon} boxSize="14px" />
              <Text fontSize="13px" fontWeight="medium">
                {stage.label}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};
